import React, { useRef, useState} from 'react'
import "./Contact.css"
import emailjs from '@emailjs/browser';

function Contact () {
    const [ displays, setDisplays ] = useState(false)
    const [ isIt, setIsIt ] = useState("")

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_0yo75z5', 'template_qhq9r1e', form.current, 'hLH9F4nQjeLHuqLX-')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                setIsIt(error.text);
            });
    };
    const handleClick = () => {
        setDisplays(true)
    }
    return (
      <div className="c-container" id='Contact'>
            <div className='contact'>
                <div>
                    <h1>Talk with Gebrekidan</h1>
                </div>
                <form ref={form} onSubmit={sendEmail}>
                    <input
                        type="text"
                        name="from_name"
                        placeholder='Your name'
                        className='input' />
                    <input
                        type="email"
                        name="from_name"
                        placeholder='Your email'
                        className='input' />
                    <textarea
                        name="message"
                        placeholder='Message'
                        cols="30" rows="10"
                        className='input'></textarea>
                    <input
                        type="submit"
                        value="Send"
                        className='button' style={{ background: "#032539", width: "8rem" }}
                        onClick={handleClick} />
                    {displays &&  (isIt === "" ? <p className='green'>Successfully sent</p> : <p className='red'>{isIt}</p>)}
                </form>
            </div>
        </div>
  )
}

export default Contact